import { Loadable } from 'shared/components'
import { ModuleRoute, UserRole } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: '/ksef',
    exact: true,
    component: Loadable({
      component: () => import('./pages/InvoiceList'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/ksef/imports',
    exact: true,
    component: Loadable({
      component: () => import('./pages/ImportList'),
    }),
    role: [UserRole.User],
  },
  {
    path: '/ksef/integration',
    exact: true,
    component: Loadable({
      component: () => import('./pages/Integration'),
    }),
    role: [UserRole.User],
  },
]

export default routes
